"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showNextDay = void 0;
const showNextDay = (endDate, selectedDate) => {
    if (!endDate || !selectedDate) {
        return false;
    }
    return endDate.startOf('day') > selectedDate.startOf('day');
};
exports.showNextDay = showNextDay;
